import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const WaitlistModal = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const { addToWaitlist } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addToWaitlist(email);
      setMessage('Thank you for joining our waitlist!');
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 max-w-md mx-auto text-center">
      <h2 className="text-3xl font-bold mb-4">Join our Waitlist</h2>
      <p className="mb-6 text-gray-600">
        Enter your email to join our waitlist and be notified when we launch.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button
          className="w-full bg-blue-400 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="submit"
        >
          Join Waitlist
        </button>
      </form>
      {message && <p className="mt-4 text-sm text-green-600">{message}</p>}
      <button
        className="mt-4 text-gray-500 hover:text-gray-700"
        onClick={onClose}
      >
        Close
      </button>
    </div>
  );
};

export default WaitlistModal;
